import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import { X } from 'react-feather';
import { useCopyToClipboard } from '@trinity/chat-components/hooks/useCopyToClipboard.js';
import type { BaseModalProps } from '@trinity/chat-components/hooks/useModal.js';
import { useAppSelector } from '@/store';
import { CopyToClipboard } from '@trinity/chat-components/components/Chat/Message.CopyToClipboard.js';

type Props = BaseModalProps;

export const SupportModal = ({ open, onClose }: Props) => {
  const supportEmail = useAppSelector((state) => state.features.supportIcon);

  const copyToClipboard = useCopyToClipboard();

  const handleCopyEmail = () => {
    copyToClipboard(supportEmail);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog fullWidth={true} maxWidth="sm" onClose={handleClose} open={open}>
      <Header>
        <Title>Support Help</Title>
        <StyledX onClick={handleClose} />
      </Header>

      <Content>
        Please reach out to our support team through email for any issues or feedback.
        <EmailRow>
          <div>
            <strong>Email:</strong> <span>{supportEmail}</span>
          </div>
          <CopyToClipboard onClick={handleCopyEmail} />
        </EmailRow>
      </Content>
    </Dialog>
  );
};

const EmailRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginTop: 20,
  gap: 10,
});

const StyledX = styled(X)({
  cursor: 'pointer',
  position: 'absolute',
  top: 15,
  right: 10,
  height: 24,
  width: 24,
});

const Header = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `15px 10px`,
  borderBottom: `1px solid ${theme.palette.gray.dark1}`,
  position: 'relative',
}));

const Title = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.bold,
  fontSize: 20,
  color: theme.palette.black.main,
}));

const Content = styled.div({
  padding: 30,
});
